module.exports = __webpack_public_path__ + "static/img/6837_phase_function_Paper_PointsHejduk_Prediction.eb6f2e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6837_phase_function_Paper_PointsHejduk_Prediction.png
// module id = o8zT
// module chunks = 0